import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { TicketService } from 'src/app/shared/services/ticket.service';
import { sportticketsApi } from 'src/app/shared/constants/api.constants';
import { IMatchTicket } from 'src/app/shared/models/match-ticket.model';
import { HelpersService, HttpBaseService } from '@evento-ng/libs';
@Component({
  selector: 'app-choose-ticket-sport',
  templateUrl: './choose-ticket-sport.component.html',
  styleUrls: ['./choose-ticket-sport.component.scss'],
})
export class ChooseTicketSportComponent {
  @Input() matchId: any;
  @Input() teamId: any;
  @Input() match: any;
  @Input() showTickets = false;
  @Input() showCartMobile = false;
  ticketCards: IMatchTicket[];
  @Output() tickets = new EventEmitter<[]>();
  isMobile = false;

  constructor(
    public ticketService: TicketService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getMatchTIckets();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  getMatchTIckets() {
    this.spinner.show();
    this.dataService
      .post(`${sportticketsApi}`, {
        matchId: this.matchId,
        teamId: this.teamId,
      })
      .subscribe((res: IMatchTicket[]) => {
        this.ticketCards = res;
        this.spinner.hide();
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.teamId) {
      this.getMatchTIckets();
    }
  }
}
